import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import CriteriaElement from './CriteriaElement';
import CriteriaListBase from '../components/CriteriaListBase';

const style = theme => ({
	root: {

	},
	title: {
		fontWeight: theme.typography.fontWeightBold,
	}
})

function CriteriaList({
	classes,
	formikProps,
	disabled = false
}) {
	const id = 'valuesList';

	const handleAdd = () => {
		formikProps.setFieldValue(id,
			[...formikProps.values[id], {
				key: '',
				value: ''
			}])
	}

	return (
		<CriteriaListBase
			id={id}
			formikProps={formikProps}
			Element={CriteriaElement}
			onAdd={handleAdd}
			disabled={disabled}
		/>
	)
}

CriteriaList.propTypes = {
	classes: PropTypes.any,
}

CriteriaList.defaultProps = {
}

export default withStyles(style)(CriteriaList);